import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const UndoIcon = ({
  title = 'UndoIcon',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 14 16" {...props}>
    {/* prettier-ignore */}
    <path d="M13.243 9.985A6.022 6.022 0 0 1 7.23 16h-2.13a.639.639 0 0 1-.638-.639v-.213c0-.352.286-.638.639-.638h2.129a4.53 4.53 0 0 0 4.524-4.525A4.53 4.53 0 0 0 7.23 5.461H3.3l2.705 2.705c.29.29.29.763 0 1.054a.763.763 0 0 1-1.054 0L.975 5.243a.74.74 0 0 1-.219-.527.74.74 0 0 1 .219-.527L4.952.21a.763.763 0 0 1 1.054 0c.29.29.29.763 0 1.054L3.3 3.97h3.928a6.022 6.022 0 0 1 6.014 6.015Z" />
  </CreateIconComponent>
);

export default UndoIcon;
